const init = () => {
  const swatches: NodeListOf<HTMLInputElement> = document.querySelectorAll("[data-radio-colour]");
  const radioInputs = document.querySelectorAll("[data-radio-size]");

  const changeSelectedSwatchLabel = () => {
    swatches.forEach(swatch => {
      if (swatch.checked) {
        const swatchLabel = document.querySelector("[data-selected-colour-label]");
        const button: HTMLElement | null = swatch.closest(".swatch__button");
        const buttonLabel = button?.querySelector("label");
        swatchLabel.textContent = buttonLabel.dataset.swatch
      }
    })
  };

  changeSelectedSwatchLabel();

  swatches.forEach(swatch => {
    if (!swatch) return;
    swatch.addEventListener("change", () => {
      changeSelectedSwatchLabel();
    });
  })

  const formattingSizeLabel = () => {
    if (window.innerWidth > 767) return;

    radioInputs.forEach(input => {
      const button: HTMLElement | null = input.closest(".radio__button");
      const label = button?.querySelector("label");
      const [size] = label.textContent.trim().split("("); // Extracts the size (e.g., "S", "M", "L") from a string formatted like "S(8)" or "L(12)"
      label.textContent = size;
    })
  }

  formattingSizeLabel();
}

document.addEventListener("DOMContentLoaded", init);
